import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import * as usersApi from './api'

export const userRoleKeys = {
  rolesOf: (userId: number) => ['access', 'user-roles', userId] as const,
  batch:   (userIds: number[]) => ['access', 'user-roles', 'batch', userIds.slice().sort().join(',')] as const,
}

export function useUserRoles(userId: number | null | undefined) {
  return useQuery({
    queryKey: userRoleKeys.rolesOf(userId ?? -1),
    queryFn: () => usersApi.listUserRoles(userId as number),
    enabled: typeof userId === 'number' && userId > 0,
  })
}

export function useRolesForUsers(userIds: number[]) {
  return useQuery({
    queryKey: userRoleKeys.batch(userIds),
    queryFn: () => usersApi.listRolesForUsers(userIds),
    enabled: userIds.length > 0,
  })
}

export function useAssignUserRole(userId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (roleCode: string) => usersApi.assignUserRole(userId, roleCode),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: userRoleKeys.rolesOf(userId) })
      qc.invalidateQueries({ queryKey: ['access', 'user-roles', 'batch'] })
      qc.invalidateQueries({ queryKey: ['contracts'] })
    },
  })
}

export function useRevokeUserRole(userId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (roleCode: string) => usersApi.revokeUserRole(userId, roleCode),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: userRoleKeys.rolesOf(userId) })
      qc.invalidateQueries({ queryKey: ['access', 'user-roles', 'batch'] })
      qc.invalidateQueries({ queryKey: ['contracts'] })
    },
  })
}
